<div class="odx-bar-parent h-100" odxLayout="flex">
  <app-configuration-wizard-back-button #backButton [project]="project" [floorplanGroup]="FloorplanMenuType.TRANSMITTER">
  </app-configuration-wizard-back-button>
  <odx-wizard #configurationWizard [vertical]="true" (activeStepChanged)="setActiveStep($event)">
    <odx-wizard-step i18n="@@transmitterConfiguration.wizard.gas">Gasart</odx-wizard-step>
    <odx-wizard-step i18n="@@transmitterConfiguration.wizard.family">Familie</odx-wizard-step>
    <odx-wizard-step i18n="@@transmitterConfiguration.wizard.transmitter">Transmitter</odx-wizard-step>
    <odx-wizard-step i18n="@@transmitterConfiguration.wizard.sensor" [class.odx-wizard-step--visible]="needsSensor"
      >Sensor</odx-wizard-step
    >
    <odx-wizard-step i18n="@@transmitterConfiguration.wizard.attachments">Zubehör</odx-wizard-step>
  </odx-wizard>

  <app-gas-selector
    class="w-100 h-100"
    [hidden]="activeStep !== 0 || (originalConfiguration && !isIncompleteConfiguration)"
    [project]="project"
    [originalGas]="originalConfiguration?.gas"
    [originalTransmitter]="originalConfiguration?.transmitter"
    [productType]="FgdsProductType.TRANSMITTER"
    (gasSelect$)="selectGas($event)"
  ></app-gas-selector>

  <app-transmitter-family-selector
    class="w-100 h-100"
    [hidden]="activeStep !== 1"
    [selectedSubstance]="selectedGas"
    [originalTransmitter]="originalConfiguration?.transmitter"
    [originalTransmitterFamily]="originalConfiguration?.family"
    (familySelect$)="selectFamily($event)"
  ></app-transmitter-family-selector>

  <app-transmitter-selector
    class="w-100 h-100"
    [project]="project"
    [hidden]="activeStep !== 2"
    [showCosts]="project.showCostFlag"
    [selectedGasData]="selectedGas"
    [selectedFamily]="selectedFamily"
    [originalConfiguration]="originalConfiguration"
    [defaultDetectionRange]="defaultDetectionRange"
    (defaultDetectionRangeChange)="defaultDetectionRange = $event"
    (transmitterSelect$)="selectTransmitter($event)"
  ></app-transmitter-selector>

  @if (selectedTransmitter) {
    <app-sensor-selector
      class="w-100 h-100"
      [hidden]="activeStep !== 3 || !needsSensor"
      [selectedProducts]="
        selectedTransmitter.id === originalConfiguration?.transmitter?.id
          ? {
              selectedGas: selectedGas,
              selectedTransmitter: selectedTransmitter,
              preselectedSensor: originalConfiguration!.sensor,
            }
          : { selectedGas: selectedGas, selectedTransmitter: selectedTransmitter }
      "
      [showCosts]="project.showCostFlag"
      (sensorSelect$)="selectedSensor = $event"
      (needsSensor$)="needsSensor = $event"
    ></app-sensor-selector>
  }
  @if (selectedTransmitter) {
    <app-attachment-selector
      class="w-100 h-100"
      [hidden]="activeStep !== 4"
      [headerProducts]="
        selectedSensor ? [selectedGas!, selectedTransmitter!, selectedSensor] : [selectedGas!, selectedTransmitter!]
      "
      [products]="
        selectedTransmitter.id === originalConfiguration?.transmitter?.id
          ? { selectedProducts: [selectedTransmitter], preselectedAttachments: originalConfiguration!.attachments }
          : { selectedProducts: [selectedTransmitter] }
      "
      [showCosts]="project.showCostFlag"
      (attachmentsSelect$)="selectedAttachments = $event"
    >
    </app-attachment-selector>
  }
  <app-product-config-stepper-bar
    (dismiss)="backButton.navigateBack()"
    (next)="onSubmit()"
    (previous)="onPrevious()"
    [activeStep]="!needsSensor && activeStep === 4 ? activeStep - 1 : activeStep"
    [steps]="steps"
    [isPreviousButtonDisabled]="activeStep === 1 && originalConfiguration !== undefined && !isIncompleteConfiguration"
  >
  </app-product-config-stepper-bar>
</div>
